const DAILYPASS_LIST_ACTIONS = {
  DAILYPASS_LIST: {
    PENDING: 'DAILYPASS_LIST_PENDING',
    SUCCESS: 'DAILYPASS_LIST_SUCCESS',
    FAILURE: 'DAILYPASS_LIST_FAILURE',
    REMOVE_LIST: 'DAILYPASS_REMOVE_LIST',
  },
}

export const DAILYPASS_LIST_STATE = {
  REFRESHED: 'DAILYPASS_LIST_REFRESHED',
  IN_PROGRESS: 'DAILYPASS_LIST_IN_PROGRESS',
  SUCCESS: 'DAILYPASS_LIST_RETRIEVED',
  ERROR: 'DAILYPASS_LIST_ERROR',
  PENDING: 'DAILYPASS_LIST_PENDING',
}

export default DAILYPASS_LIST_ACTIONS
